import React, { Component } from 'react';
import OperationsLayout from './OperationsLayout';
import SettingsLayout from './settings/SettingsLayout';
import Home from './home/Home';
import ToDo from './toDo/List/ToDoList';
import TopBar from '../components/topbar';
import ModalRoot from './modals/ModalRoot';
import ProfileLayout from './ProfileLayout';
import Chat from './chat';
import { uiRouts } from '../constants';
import PrivateRoute from '../components/privateRoute/privateRoute';
import WildLifeLayout from './WildLifeLayout';
import LeaseLayout from './LeaseLayout';

class MainLayout extends Component {
  componentDidMount() {
    const ApiKey = process.env.REACT_APP_GMAPS_KEY;
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=${ApiKey}`;
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
  }

  render() {
    return (
      <>
        <TopBar />
        <PrivateRoute exact path={uiRouts.root} component={Home} />
        <PrivateRoute exact path={uiRouts.todo} component={ToDo} />
        <PrivateRoute path={uiRouts.messenger} component={Chat} />
        <PrivateRoute path={uiRouts.settings} component={SettingsLayout} />
        <PrivateRoute path={uiRouts.ops} component={OperationsLayout} />
        <PrivateRoute path={uiRouts.profile} component={ProfileLayout} />
        <PrivateRoute path={uiRouts.wildlife} component={WildLifeLayout} />
        <PrivateRoute path={uiRouts.lease} component={LeaseLayout} />
        <ModalRoot />
      </>
    );
  }
}

export default MainLayout;
